import React from 'react';
import PropTypes from 'prop-types';

const HeartIcon = ({ color }) => (
  <svg
    width="29"
    height="25"
    viewBox="0 0 29 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.7451 5.13948C27.3132 4.13928 26.6903 3.23292 25.9114 2.47112C25.132 1.70704 24.213 1.09985 23.2044 0.682542C22.1586 0.248106 21.0369 0.0257364 19.9044 0.028343C18.3156 0.028343 16.7655 0.463401 15.4185 1.28518C15.0962 1.48176 14.79 1.69768 14.5 1.93293C14.21 1.69768 13.9038 1.48176 13.5815 1.28518C12.2345 0.463401 10.6844 0.028343 9.0956 0.028343C7.95156 0.028343 6.84297 0.247484 5.79561 0.682542C4.78369 1.10149 3.87168 1.70412 3.08857 2.47112C2.30868 3.23206 1.68568 4.13864 1.25488 5.13948C0.806934 6.18039 0.578125 7.28576 0.578125 8.42336C0.578125 9.49651 0.797266 10.6148 1.23232 11.7524C1.59648 12.703 2.11855 13.6892 2.78564 14.685C3.84268 16.2609 5.29609 17.9044 7.10078 19.5705C10.0914 22.3323 13.053 24.2402 13.1787 24.3175L13.9425 24.8073C14.2809 25.0233 14.7159 25.0233 15.0543 24.8073L15.8181 24.3175C15.9438 24.2369 18.9021 22.3323 21.896 19.5705C23.7007 17.9044 25.1541 16.2609 26.2111 14.685C26.8782 13.6892 27.4035 12.703 27.7645 11.7524C28.1995 10.6148 28.4187 9.49651 28.4187 8.42336C28.4219 7.28576 28.1931 6.18039 27.7451 5.13948Z"
      fill={color || '#84E075'}
    />
  </svg>
);

HeartIcon.propTypes = {
  color: PropTypes.string,
};

export default HeartIcon;
